import React from "react";

const ServiceCard = ({
  service,
  onClick,
  className = "",
  style = {},
}) => {
  if (!service) return null;

  return (
    <div
      className={`card shadow-sm p-3 bg-white border-0 rounded-4 d-flex flex-column cursor-pointer ${className}`}
      style={style}
      onClick={onClick}
    >
      <div style={{ height: 200, overflow: "hidden", borderRadius: 15 }}>
        <img
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
          src={service.image}
          alt={service.title}
        />
      </div>

      <div className="card-body d-flex flex-column flex-grow-1">
        <h4 className="fw-bold text-center mb-3">{service.title}</h4>
        <p className="text-center flex-grow-1">{service.description}</p>
      </div>
    </div>
  );
};

export default ServiceCard;
